import { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch } from '../store';

import { promptsApi } from 'services/prompts';
import { usersApi } from 'services/users';
import { qualificationQuestionsApi } from 'services/qualification-questions';
import { videoQuestionsApi } from 'services/video-questions';
import { videoQuestionTestResultsApi } from 'services/video-question-test-results';
import { requisitionsApi } from 'services/requisitions';
import { resumeProfilesApi } from 'services/resume-profiles';
import { resumeProfileTestResultsApi } from 'services/resume-profile-test-results';
import { applicantsApi } from 'services/applicants';
import { resourcesApi } from 'services/resources';
import { rolesApi } from 'services/roles';
import { lobsApi } from 'services/lines-of-business';
import { newApplicantsApi } from 'services/new-applicants';
import { videoQuestionProfilesApi } from 'services/video-question-profiles';
import { qualificationQuestionProfilesApi } from 'services/qualification-question-profiles';
import { typingTestsApi } from 'services/typing-tests';
import { typingAssessmentTestResultsApi } from 'services/typing-assessment-test-results';
import { talentDiscoveryApi } from 'services/talent-discovery';

const LocationChangeReset = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const params = useMemo(() => {
    const excludeParams = ['page', 'limit', 'search', 'filters'];
    return Array.from(searchParams.entries())
      .filter(([k]) => !excludeParams.some((p) => k.startsWith(p)))
      .reduce((str, [k, v]) => str + `${k}:${v};`, '');
  }, [searchParams]);

  useEffect(() => {
    dispatch(promptsApi.util.resetApiState());
    dispatch(requisitionsApi.util.resetApiState());
    dispatch(videoQuestionsApi.util.resetApiState());
    dispatch(videoQuestionTestResultsApi.util.resetApiState());
    dispatch(resumeProfilesApi.util.resetApiState());
    dispatch(videoQuestionProfilesApi.util.resetApiState());
    dispatch(qualificationQuestionProfilesApi.util.resetApiState());
    dispatch(resumeProfileTestResultsApi.util.resetApiState());
    dispatch(qualificationQuestionsApi.util.resetApiState());
    dispatch(talentDiscoveryApi.util.resetApiState());
    dispatch(usersApi.util.resetApiState());
    dispatch(resourcesApi.util.resetApiState());
    dispatch(applicantsApi.util.resetApiState());
    dispatch(newApplicantsApi.util.resetApiState());
    dispatch(rolesApi.util.resetApiState());
    dispatch(lobsApi.util.resetApiState());
    dispatch(typingTestsApi.util.resetApiState());
    dispatch(typingAssessmentTestResultsApi.util.resetApiState());
  }, [location.pathname, params, dispatch]);

  return null;
};

export default LocationChangeReset;
